import { render, staticRenderFns } from "./barrett-jackson.vue?vue&type=template&id=536f9116&scoped=true&"
import script from "./barrett-jackson.vue?vue&type=script&lang=js&"
export * from "./barrett-jackson.vue?vue&type=script&lang=js&"
import style0 from "./barrett-jackson.vue?vue&type=style&index=0&id=536f9116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536f9116",
  null
  
)

export default component.exports